import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { optionalEnv, requireEnv } from '../config/env';

const firebaseConfig = {
    apiKey: requireEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: requireEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: requireEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: requireEnv('VITE_FIREBASE_APP_ID'),
    measurementId: optionalEnv('VITE_FIREBASE_MEASUREMENT_ID') ?? ''
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// TEST ONLY: point the SDK at local Firebase emulators for the E2E harness.
// No-op (and dead code in prod builds, since VITE_E2E is never set there).
if (import.meta.env.VITE_E2E === '1') {
    const firestoreEmulator = optionalEnv('VITE_E2E_FIRESTORE_EMULATOR') ?? 'localhost:8090';
    const [firestoreHost, firestorePortStr] = firestoreEmulator.split(':');
    connectFirestoreEmulator(db, firestoreHost, Number(firestorePortStr) || 8090);

    const authEmulatorUrl = optionalEnv('VITE_E2E_AUTH_EMULATOR') ?? 'http://localhost:9099';
    connectAuthEmulator(auth, authEmulatorUrl, { disableWarnings: true });
}
